import React, { useState, useEffect } from "react"
import { useParams } from "wouter"
import { ClientGate } from "../../components/ClientGate"
import { buildStyleMap } from "./utils"
import { HeroBlock }        from "./blocks/HeroBlock"
import { OverviewBlock }    from "./blocks/OverviewBlock"
import { TracksBlock }      from "./blocks/TracksBlock"
import { TimelineBlock }    from "./blocks/TimelineBlock"
import { TopicsBlock }      from "./blocks/TopicsBlock"
import { MeasurementBlock } from "./blocks/MeasurementBlock"
import registry from "./registry.json"

function ProgrammeRenderer({ programme }) {
  const [hoveredTrack, setHoveredTrack] = useState(null)
  const styleMap = buildStyleMap(programme.tracks)

  const hasTopics = programme.mentor_pathway || programme.sessions?.some(s => s.topic_candidates?.length > 0)

  return (
    <div style={{ background: "#000", color: "#fff", minHeight: "100vh", fontFamily: "Inter, system-ui, -apple-system, sans-serif" }}>
      <HeroBlock programme={programme} />
      {programme.description && (
        <OverviewBlock programme={programme} />
      )}
      {programme.tracks?.length > 0 && (
        <TracksBlock
          programme={programme}
          styleMap={styleMap}
          hoveredTrack={hoveredTrack}
          setHoveredTrack={setHoveredTrack}
        />
      )}
      {programme.sessions?.length > 0 && (
        <TimelineBlock
          programme={programme}
          styleMap={styleMap}
          hoveredTrack={hoveredTrack}
          setHoveredTrack={setHoveredTrack}
        />
      )}
      {hasTopics && <TopicsBlock programme={programme} />}
      {(programme.measurement?.leading_indicators?.length > 0 || programme.measurement?.levels?.length > 0) && (
        <MeasurementBlock programme={programme} styleMap={styleMap} />
      )}
    </div>
  )
}

function NotFound({ clientId }) {
  return (
    <div style={{ background: "#000", color: "#fff", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Inter, sans-serif" }}>
      <div style={{ textAlign: "center" }}>
        <p style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", opacity: 0.35, marginBottom: 16 }}>Client Portal</p>
        <p style={{ fontSize: 18, opacity: 0.6 }}>No programme found for <code style={{ opacity: 0.8 }}>{clientId}</code>.</p>
      </div>
    </div>
  )
}

export function ClientPage() {
  const { clientId } = useParams()
  const config = registry[clientId]
  const [programme, setProgramme] = useState(null)
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    if (!config) { setNotFound(true); return }
    import(`./data/${clientId}.json`)
      .then(m => setProgramme(m.default?.programme || m.default))
      .catch(() => setNotFound(true))
  }, [clientId, config])

  if (notFound) return <NotFound clientId={clientId} />
  if (!programme) return null

  return (
    <ClientGate clientId={clientId} password={config.password}>
      <ProgrammeRenderer programme={programme} />
    </ClientGate>
  )
}
